// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "im.token",
    name: "imToken",
    homepage: "https://token.im/",
    image_id: "99520548-525c-49d7-fb2f-5db65293b000",
    app: {
        browser: "https://token.im/",
        ios: "https://apps.apple.com/us/app/imtoken2/id1384798940",
        android: "https://play.google.com/store/apps/details?id=im.token.app",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "imtokenv2://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map